const BASE_URL = `${process.env.REACT_APP_EXPERIAN_API}`;

export const downloadFileFromURL = (filePath) => {
    const BASE_URL = `${process.env.REACT_APP_EXPERIAN_API}`;
    const url = `${BASE_URL}/experian/downloadFile?downloadFile=${encodeURIComponent(filePath)}`;
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
};


